const form = {
  formId: "tax-personal-06",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    checkbox1: {
      name: "checkbox1",
      label: "Cá nhân được miễn, giảm thuế theo Hiệp định tránh đánh thuế hai lần (*)",
    },
    fullName1: {
      name: "fullName1",
      label: "[04] Họ và tên",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập họ và tên",
    },
    taxId1: {
      name: "taxId1",
      label: "[05] Mã số thuế",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    identity: {
      name: "identity",
      label: "[06] Số CMND/CCCD/Hộ chiếu",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập CMND/CCCD/Hộ chiếu",
      invalidMsg: "CMND/CCCD/Hộ chiếu không hợp lệ",
    },
    national: {
      name: "national",
      label: "[07] Quốc tịch",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn quốc tịch",
    },
    address: {
      name: "address",
      label: "[08] Địa chỉ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    district: {
      name: "district",
      label: "[09] Quận/huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    province: {
      name: "province",
      label: "[10] Tỉnh/thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[14] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[15] Mã số thuế đại lý",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    makeIn: {
      name: "makeIn",
      label: "[17] Làm tại",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập",
    },
    dateMakeIn: {
      name: "dateMakeIn",
      label: "Ngày",
      type: "number",
      errorMsg: "Vui lòng chọn ngày",
    },
    dateAccepted: {
      name: "dateAccepted",
      label: "Đã được cơ quan công chứng chứng nhận ngày",
      type: "number",
      errorMsg: "Vui lòng chọn ngày chứng nhận",
    },

    fullName2: {
      name: "fullName2",
      label: "[18] Họ và tên",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId2: {
      name: "taxId2",
      label: "[19] Mã số thuế",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    identity2: {
      name: "identity2",
      label: "[20] Số CMND/CCCD/Hộ chiếu",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập CMND/CCCD/Hộ chiếu",
      invalidMsg: "CMND/CCCD/Hộ chiếu không hợp lệ",
    },
    national2: {
      name: "national2",
      label: "[21] Quốc tịch",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn quốc tịch",
    },
    address2: {
      name: "address2",
      label: "[22] Địa chỉ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    district2: {
      name: "district2",
      label: "[22] Quận/huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    province2: {
      name: "province2",
      label: "[22] Tỉnh/thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },

    phone: {
      name: "phone",
      label: "[23] Điện thoại",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax: {
      name: "fax",
      label: "[24] Fax",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email: {
      name: "email",
      label: "[25] Email",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    checkbox2: {
      name: "checkbox2",
      label: "[26] Chứng khoán",
    },
    checkbox3: {
      name: "checkbox3",
      label: "[27] Vốn góp",
    },
    checkbox4: {
      name: "checkbox4",
      label: "[28] Tài sản phải đăng ký chủ sở hữu hoặc sử dụng",
    },
    certificateProperty: {
      name: "certificateProperty",
      label: "V(a). [29] GIẤY CHỨNG NHẬN QUYỀN SỬ DỤNG HOẶC SỞ HỮU TÀI SẢN THỪA KẾ, QUÀ TẶNG SỐ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập",
    },
    certificatePropertyByWho: {
      name: "certificatePropertyByWho",
      label: "Do cơ quan",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập",
    },
    certificatePropertyDate: {
      name: "certificatePropertyDate",
      label: "Cấp ngày",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập",
    },
    organizationInfo: {
      name: "organizationInfo",
      label: "V(b). THÔNG TIN TỔ CHỨC PHÁT HÀNH CHỨNG KHOÁN HOẶC TỔ CHỨC NƠI CÁ NHÂN CÓ VỐN GÓP",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập",
    },

    organizationName: {
      name: "organizationName",
      label: "[30] Tên tổ chức",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức",
    },
    taxId3: {
      name: "taxId3",
      label: "[31] Mã số thuế",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    district3: {
      name: "district3",
      label: "[33] Quận/huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    province3: {
      name: "province3",
      label: "[34] Tỉnh/thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    address3: {
      name: "address3",
      label: "[32] Địa chỉ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    phone2: {
      name: "phone2",
      label: "[35] Điện thoại",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax2: {
      name: "fax2",
      label: "[36] Fax",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email2: {
      name: "email2",
      label: "[37] Email",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    amount1: {
      name: "amount1",
      label: "[38] Số tiền",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số tiền",
    },
    amount2: {
      name: "amount2",
      label: "[39] Số tiền",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số tiền",
    },

    // footer
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
